import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

import MainLayout from 'core/ui/layouts/MainLayout';

ReactDOM.render(<MainLayout />, document.getElementById('root'));
registerServiceWorker();
